import script from "./FifthScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./FifthScreen.vue?vue&type=script&setup=true&lang=js"

import "./FifthScreen.vue?vue&type=style&index=0&id=737288e5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-737288e5"]])

export default __exports__